import { useState, useEffect, useCallback } from 'react';

import { UseScrollState } from './types';

const useScroll = (): UseScrollState => {
  const [scrollState, setScrollState] = useState<UseScrollState>({ x: 0, y: 0 });

  const handleScroll = useCallback(() => {
    if (window) {
      setScrollState((prevState) => ({
        ...prevState,
        y: window.scrollY,
        x: window.scrollX,
      }));
    }
  }, [scrollState]);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll, {
        passive: true,
      } as unknown as EventListenerOptions);
    };
  }, [scrollState]);

  return scrollState;
};

export default useScroll;
